<template>
  <div>
    <h1>{{title}}</h1>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: [ 'title' ],
  watch: {
    // This would be called anytime the value of title changes
    title(newValue, oldValue) {
      //console.log('change from ' + oldValue + ' to ' + newValue);
    }
  }
}
</script>